// Categories extension (admin side): where the product is listed.
// The tab is the old catalog editor's CategoriesTab, reused as it is — it reads and
// writes through the shared catalog editor (../shared/catalog-editor.jsx).
import { TagIcon } from "@heroicons/react/24/outline"
import CategoriesTab from "./CategoriesTab"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"
import { reviewBadge } from "../shared/review-marks"

export const StoreProductExtension = {
  id: "categories",
  label: "Categories",
  description: "The categories the product is listed in, the first one drives the breadcrumb",
  section: {
    component: catalogSection(CategoriesTab),
    label: "Categories",
    icon: TagIcon,
    // what a reviewer marked here for the vendor (shared/review-marks)
    badge: reviewBadge("categories"),
    order: 560,
    visible: catalogVisible("categories"),
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
